<template>
  <div class="event-view">
    <div v-if="event">
      <div class="grid-x grid-padding-x align-middle">
          <div class="cell auto">
            <h1>{{ event.title }}</h1>
          </div>
          <div class="cell shrink">
            <router-link 
              :to="'/calendar'"
              class="btn btn-secondary">
              Back to calendar
            </router-link>
          </div>
      </div>
      <img 
        v-if="event.image_url"
        :src="event.image_url" 
        class="right"
        style="max-width:300px">
      <div v-html="event.description"></div>
      <div v-if="contacts">
        <h4 style="margin-top: 1.5rem">More information:</h4>
        <p v-for="(contact, index) in contacts" :key="index">
          <span v-if="contact.title">{{ contact.title }} at </span>
          <a 
            v-if="contact.phone" 
            :href="'tel:' + contact.phone">
            {{ contact.phone }}
          </a> 
          <a 
            v-if="contact.email" 
            :href="'mailto:' + contact.email">
            {{ contact.email }}
          </a>
        </p>
      </div>
      <div v-if="dates">
        <h4 style="margin-top: 1.5rem">Upcoming dates for this event:</h4>
        <table class="align-top compact">
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody>
            <tr 
              v-for="(date_obj, index) in dates" 
              :key="index">
              <td class="nowrap">{{ date_obj.start_datetime | date }}</td>
              <td class="nowrap">{{ date_obj.start_datetime | time }}</td>
              <td>
                <a 
                  v-if="date_obj.location.lat" 
                  href="#" 
                  @click.prevent="viewMap(date_obj.location)">
                  {{ getLocationString(date_obj.location) }}
                </a>
                <span v-else>{{ getLocationString(date_obj.location) }}</span>
              </td>
            </tr>
          </tbody> 
        </table>
      </div>
    </div>
    <div v-else>
      <loading v-if="status.busy" label="Loading event..."></loading>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import LeafletMap from '@/LeafletMap.vue'
import Loading from '@/Loading.vue'

export default {
  name: 'EventView',
  components: {
    Loading
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      status: {
        busy: false,
        error: false
      },
      event: false
    }
  },
  methods: {
    getEvent () {
      this.status.busy = true

      axios.post(this.config.url + '/event', {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        params: {
          event_id: this.id
        },
        responseType: 'json'
      })
      .then(function (response) {
        if (response.data.success) {
          this.event = response.data.event
        } else {
          this.status.error = response.data.message
        }
      }.bind(this))
      .catch(function (error) {
        this.status.error = error
      }.bind(this))
      .finally(function () {
        this.status.busy = false
      }.bind(this))
    },
    getLocationString (location) {
      return location.title
    },
    viewMap (location) {
      this.$modal.show(
        LeafletMap,
        {
          title: location.title,
          latlng:  [location.lat, location.lng]
        },
        {
          name: 'modal-leaflet-map',
          width: 600,
          height: 400
        }
      )
    }
  },
  filters: {
    date (val) {
      let dt = dayjs(val)
      return val ? dt.format('MMMM D, YYYY') : ''
    },
    time (val) {
      let dt = dayjs(val)
      return val ? dt.format('h:mm a') : ''
    }
  },
  computed: {
    config () {
      return this.$root.$options.config
    },
    contacts () {
      if (this.event && this.event.contacts.length) {
        return this.event.contacts
      }
      return false
    },
    dates () {
      if (this.event && this.event.dates.length) {
        return this.event.dates
      }
      return false
    }
  },
  mounted () {
    this.getEvent()
  }
}
</script>
